export default{
    buyerCenter:{
        Notification:{
           
        },
        Message:{
            delete:{
                success:'删除成功！',
            },
        },
        Alert:{

        },
        Button:{
            
        },
        Placeholder:{

        },
        Validate:{

        },
        Description:{
            module1:{
                title:'采购订单',
                more:'查看全部',
                status:['待确认','待付款','待发货','待备货','待收货','待自提','退货退款'],
                item:{
                    text1:'订单编号：',
                    text2:'剩余',
                    text3:'尾款未付',
                    text4:'立即付款',
                    text5:'支付尾款',
    
                    text6:'确认收货',
                    text7:'确认自提',
                    text8:'订单详情',
                    text9:'售后详情',
                    text10:'取消订单',
                    text11:'申请退款',
                    text12:'删除订单',
                    text13:'共',
                    text14:'件商品',
                }
            },
            module2:{
                title:'我的收藏',
                more:'查看全部',
                item:{
                    text1:'累计销量：',
                    text2:'笔',
                },
                noData:{
                    text1:'暂无收藏',
                    text2:'我要',
                    text3:'添加收藏',
                }
            },
        },
        Checkbox:{
            
        },
        Table:{

        },
        ValidData:{
            
        },
        InvalidData:{
            
        },
        Dialog:{
            title:'选择取消原因',
            text:'订单取消成功后将无法恢复',
            cancel:'取消',
            confirm:'确认',
            message:{
                error:'请选择取消原因后提交！',
                success:'订单取消成功！'
            }
        },
        Confirm:{
            cancel:'取消',
            confirm:'确认',
            collectDelete:{
                title:'删除提示',
                text:'是否删除该收藏？',
            },
            orderDelete:{
                title:'删除提示',
                text:'是否删除该订单？',
            },
            message:{
                title1:'确认收货提示',
                text1:'是否确认货品已经收到且根据验收标准确认货品完好',
                title2:'确认自提',
                text2:'是否确认货品已经取到且根据验收标准确认货品完好',
                success:'已完成收货',
            }
        }
    }
    
}